import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  extractSections,
  getLevelNumber,
  handleDomChange,
  truncateByWords,
} from "../Utility/Leftpanel";
import { useConfig } from "../config";
import { Resizable } from "re-resizable";

const LeftPanel = ({ setShowNavBar, showNavBar, dom, content, editor }) => {
  const [show, setShow] = useState(false);
  const [gData, setGData] = useState([]);
  const [draggedGroupKeys, setDraggedGroupKeys] = useState([]);
  const [isResizing, setIsResizing] = useState(false);
  const { config } = useConfig();
  const [width, setWidth] = useState(
    showNavBar ? (config.treeView ? 0 : 340) : config.treeView ? 0 : 40
  );
  // Handle fetching tree data from the DOM
  const handleGetTreeData = (dom) => {
    const sideContent = [];

    const pushIfExists = (element, title, level) => {
      if (element) {
        const key = element.getAttribute("key") || "";
        sideContent.push({
          key,
          title,
          level: `level${level}`,
          movable: false,
        });
      }
    };

    const front = dom?.querySelector("front");
    const main = dom?.querySelector("body1");
    const back = dom?.querySelector("back");
    const ack = back?.querySelector("ack");
    pushIfExists(front?.querySelector("article-title"), "Article Title", 1);
    pushIfExists(front?.querySelector("contrib-group"), "Authors", 2);
    if (main) {
      sideContent.push(...extractSections(main));
    }
    if (ack) {
      const p1 = ack.querySelector("p");
      const key = p1.getAttribute("key") || "";
      const titleText = "Acknowledgement";
      sideContent.push({
        key,
        title: titleText,
        level: "level2",
        movable: false,
      });
    }
    const fnGroup = back?.querySelector("fn-group");
    if (fnGroup) {
      const backTags = fnGroup.querySelectorAll("fn1");
      backTags.forEach((fn) => {
        const key = fn.getAttribute("key") || "";
        const title1 = fn.querySelector("bold");
        const titleText = title1?.textContent.trim() || "";

        sideContent.push({
          key,
          title: titleText,
          level: "level2",
          movable: false,
        });
      });
    }

    const refTitle = back?.querySelector("ref-list > title1");
    if (refTitle) {
      const key = refTitle.getAttribute("key") || "";
      const titleText = refTitle.textContent.trim();
      sideContent.push({
        key,
        title: titleText,
        level: "level2",
        movable: false,
      });
    }

    setGData(sideContent);
  };

  // Scroll to the clicked element in the DOM
  const handleClick = (e, key) => {
    const editorbody = dom;

    if (key) {
      const targetElement = editorbody?.querySelector(`[key="${key}"]`);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  //  Drag and Drop Functionalities

  const getGroup = (startIndex) => {
    const draggedItem = gData[startIndex];
    if (!draggedItem) return [];

    const group = [draggedItem.key.toString()];
    for (let i = startIndex + 1; i < gData.length; i++) {
      if (getLevelNumber(gData[i].level) > getLevelNumber(draggedItem.level)) {
        group.push(gData[i].key.toString());
      } else {
        break;
      }
    }
    return group;
  };

  const handleDragStart = (start) => {
    const group = getGroup(start.source.index);
    setDraggedGroupKeys(group);
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    const dKey = gData[destination.index].key;
    const sKey = gData[source.index].key;
    const dlevel = gData[destination.index].level;
    const slevel = gData[source.index].level;
    const position = destination.index - source.index;
    if (!destination) return;

    if (draggedGroupKeys.length > 1) {
      const items = Array.from(gData);
      const groupItems = items.filter((i) =>
        draggedGroupKeys.includes(i.key.toString())
      );
      const remainingItems = items.filter(
        (i) => !draggedGroupKeys.includes(i.key.toString())
      );

      const destIndex = remainingItems.findIndex((item) => item.key === dKey);

      if (position > 0) {
        remainingItems.splice(destIndex + 1, 0, ...groupItems);
        setGData(remainingItems);
      } else if (position < 0) {
        remainingItems.splice(destIndex, 0, ...groupItems);
        setGData(remainingItems);
      }
    } else {
      const items = Array.from(gData);
      const [removed] = items.splice(source.index, 1);
      items.splice(destination.index, 0, removed);
      setGData(items);
    }
    handleDomChange(
      { key: sKey, level: slevel },
      { key: dKey, level: dlevel },
      position,
      dom,
      editor
    );
    setDraggedGroupKeys([]);
  };

  useEffect(() => {
    if (showNavBar) {
      setTimeout(() => {
        setShow((prev) => !prev);
      }, 300);
    } else {
      setShow(false);
    }
  }, [showNavBar]);

  useEffect(() => {
    if (dom) {
      handleGetTreeData(dom);
    }
  }, [show,dom]);
  useEffect(() => {
    if (!editor || !showNavBar) return;

    const handler = () => {
      if (dom) {
        handleGetTreeData(dom);
        
      }
    };

    // Trigger only when content changes
    editor.on("change", handler);

    return () => {
      editor.off("change", handler);
    };
  }, [editor]);

  useEffect(() => {
    if (!isResizing) {
      setWidth(
        showNavBar ? (config.treeView ? 0 : 340) : config.treeView ? 0 : 40
      );
    }
  }, [showNavBar, isResizing]);

  return (
    <>
      <Resizable
        size={{ width, height: "100%"}}
        minWidth={
          showNavBar ? (config.treeView ? 0 : 300) : config.treeView ? 0 : 40
        }
        maxWidth={600}
        style={{
          transition: "all 0.3s linear",
          overflow: "hidden",
          paddingTop:"0" 
        }}
        enable={{ top: false, right: showNavBar, bottom: false, left: false }}
        onResizeStop={(e, direction, ref) => {
          setIsResizing(false);
          setWidth(ref.offsetWidth);
        }}
      >
        {!config.treeView && (
          <div
            className={` 
     w-full h-full
  `}
          >
            <div className="w-full bg-leftPanelbg h-full px-2 pt-3 editor-sidebar">
              <div className="flex pb-3 items-center">
                <button
                  onClick={() => setShowNavBar((prev) => !prev)}
                  className="outline-none border-none w-[25px]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="blue"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M3 6h18M3 12h18M3 18h18"
                    ></path>
                  </svg>
                </button>
                <h4
                  className={`${
                    show ? "block" : "hidden"
                  } text-[18px] text-center text-primary font-semibold w-full`}
                >
                  Table Of Contents
                </h4>
              </div>

              {gData.length && show ? (
                <DragDropContext
                  onDragEnd={handleDragEnd}
                  onDragStart={handleDragStart}
                >
                  <Droppable droppableId="leftPanel">
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="flex flex-col max-h-[calc(100%-44px)] overflow-auto leftpanel-content gap-2"
                      >
                        {gData.map((item, index) => {
                          const isPartOfDraggedGroup =
                            draggedGroupKeys.includes(item.key);

                          return (
                            <Draggable
                              key={item.key}
                              draggableId={item.key.toString()}
                              index={index}
                              isDragDisabled={!item.movable}
                            >
                              {(provided, snapshot) => {
                                if (
                                  snapshot.isDragging &&
                                  draggedGroupKeys[0] === item.key
                                ) {
                                  return (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      {draggedGroupKeys.map((gKey) => {
                                        const gItem = gData.find(
                                          (i) => i.key === gKey
                                        );
                                        return (
                                          <p
                                            key={gKey}
                                            onClick={(e) =>
                                              handleClick(e, gKey)
                                            }
                                            className={`${gItem.level} cursor-pointer text-[16px] px-2 py-1 relative flex items-center gap-4 rounded-[4px] text-leftPanel hover:bg-leftPanelContentbg hover:text-leftPanelHover`}
                                          >
                                            <span
                                              className={`mt-[6px] ${
                                                gItem.movable ? "" : "hidden"
                                              }`}
                                              {...(gItem.movable
                                                ? provided.dragHandleProps
                                                : {})}
                                            >
                                              <svg
                                                viewBox="64 64 896 896"
                                                focusable="false"
                                                data-icon="holder"
                                                width="1em"
                                                height="1em"
                                                fill="currentColor"
                                                aria-hidden="true"
                                              >
                                                <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                                              </svg>
                                            </span>
                                            <span
                                              className={`${
                                                gItem.movable ? "pl-3" : ""
                                              }`}
                                            >
                                              {truncateByWords(gItem.title)}
                                            </span>
                                          </p>
                                        );
                                      })}
                                    </div>
                                  );
                                }

                                if (
                                  snapshot.isDragging ||
                                  isPartOfDraggedGroup
                                ) {
                                  return (
                                    <p
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      style={{ opacity: 0.2 }}
                                      className={`${item.level} ${
                                        item.movable ? "pl-0" : ""
                                      } cursor-pointer  text-[16px] px-2 py-1 relative flex items-start  rounded-[4px] text-leftPanel hover:bg-leftPanelContentbg hover:text-leftPanelHover `}
                                    >
                                      <span
                                        className={`ml-1 mt-[5px] ${
                                          item.movable ? "" : "hidden"
                                        }`}
                                      >
                                        <svg
                                          viewBox="64 64 896 896"
                                          focusable="false"
                                          data-icon="holder"
                                          width="1em"
                                          height="1em"
                                          fill="currentColor"
                                          aria-hidden="true"
                                        >
                                          <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                                        </svg>
                                      </span>
                                      <span
                                        className={`${
                                          item.movable ? "pl-3" : ""
                                        }`}
                                      >
                                        {truncateByWords(item.title)}
                                      </span>
                                    </p>
                                  );
                                }

                                return (
                                  <p
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...(item.movable
                                      ? provided.dragHandleProps
                                      : {})}
                                    onClick={(e) => handleClick(e, item.key)}
                                    className={`${item.level} ${
                                      item.movable ? "pl-0" : ""
                                    } cursor-pointer  text-[16px] px-2 py-1 relative flex items-start  rounded-[4px] text-leftPanel hover:bg-leftPanelContentbg hover:text-leftPanelHover `}
                                  >
                                    <span
                                      className={`ml-1 mt-[5px] ${
                                        item.movable ? "" : "hidden"
                                      }`}
                                      {...(item.movable
                                        ? provided.dragHandleProps
                                        : {})}
                                    >
                                      <svg
                                        viewBox="64 64 896 896"
                                        focusable="false"
                                        data-icon="holder"
                                        width="1em"
                                        height="1em"
                                        fill="currentColor"
                                        aria-hidden="true"
                                      >
                                        <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"></path>
                                      </svg>
                                    </span>
                                    <span
                                      className={`${
                                        item.movable ? "pl-3" : ""
                                      }`}
                                    >
                                      {truncateByWords(item.title)}
                                    </span>
                                  </p>
                                );
                              }}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : null}
            </div>
          </div>
        )}
      </Resizable>
    </>
  );
};

export default LeftPanel;
